import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class GatewatSms extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/gateway/sms'
    super(store, path)
  }
}
